import { CodeBlockNode, HeadingNode, LinkMark, type TextNode, type TipTapBaseNode, type TipTapRenderHandlers, type TipTapBaseMark, type TipTapNodeHandler } from "./interfaces";

function mapMarkToClassName(mark: TipTapBaseMark) {
	if (mark.type === "bold") return "font-bold";
	if (mark.type === "italic") return "italic";
	if (mark.type === "underline") return "underline";
	if (mark.type === "strike") return "line-through";
	if (mark.type === "code") return "font-mono";
	if (mark.type === "link") return "text-blue-500";
	if (mark.type === "h1") return "text-3xl font-bold";
	if (mark.type === "h2") return "text-xl font-bold";
	if (mark.type === "h3") return "text-lg font-bold";
	if (mark.type === "h4") return "text-base font-bold";
	return "";
};
function mapAlignClassName(textAlign: string) {
	if (textAlign === "left") return "text-left";
	else if (textAlign === "center") return "text-center"
	else if (textAlign === "right") return "text-right"
	else return "text-left";
}
function mapMarkToStyle(mark: TipTapBaseMark) {
	if (mark.type === "textStyle") return { color: mark.attrs?.color };
	return {};
}
// inspired by https://github.com/wokaylabs/tiptap-renderer/blob/main/src/tip-tap-render.tsx
export function TipTapRender(props: { node: TipTapBaseNode; handlers: TipTapRenderHandlers }): JSX.Element {
	const nodeType = props.node.type;
	if (nodeType === "doc") {
		const children = props.node.content ?? [];
		return <>
			{children.map((child, ix) => <TipTapRender node={child} handlers={props.handlers} key={ix} />)}
		</>
	} else if (nodeType === "heading") {
		const Heading = props.handlers[nodeType] as any;
		return <Heading node={props.node}>{props.node.content?.map((child, ix) => {
			return <TipTapRender node={child} handlers={props.handlers} key={ix} />
		})}</Heading>
	} else if (nodeType === "text") {
		const { text, marks } = (props.node as TextNode);
		const className = marks?.map(mark => mapMarkToClassName(mark)).join(" ");
		const styleArray = marks?.map(mark => mapMarkToStyle(mark));
		const style = styleArray ? Object.assign({}, ...styleArray) : undefined;
		const Text = props.handlers[nodeType] as any;
		return <Text node={props.node} className={className} style={style} />
	} else if (nodeType === "codeBlock" || (nodeType === "paragraph" && !props.node.content)) {
		return <></>
	}
	else {
		const textAlign = props.node.attrs?.textAlign;
		const className = mapAlignClassName(textAlign);
		const Comp = props.handlers[nodeType] as any;
		return <Comp className={className} node={props.node}>{props.node.content?.map((child, ix) => <TipTapRender node={child} handlers={props.handlers} key={ix} />)}</Comp>
	}
}